import { EmissionVisualizationModule } from './emission/emission-visualization.module';
import { NgModule } from "@angular/core";

@NgModule({
  imports: [
    EmissionVisualizationModule,
  ]
})
export class EmissionCreditVisualizationModule {}
